module.exports = __webpack_public_path__ + "static/media/1.0cb04c7c.jpg";